import { RepairShopThisBookableInfo } from "../../model/RepairShop/This/Bookable";
import { RepairShopThisBookableDateInfo } from "../../model/RepairShop/This/BookableDate";
import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";

const URL = "/repair-shops/this";

/**
 * 장착점 예약가능 날짜 리스트 조회
 * @returns
 */
export const fetchBookableDate =
  async (): Promise<RepairShopThisBookableDateInfo> => {
    const url = `${URL}/bookable-date`;
    const response = await httpRequest({ method: axiosUtils.GET, url });

    return response?.data.row;
  };
/**
 * 장착점 예약가능 시간 리스트 조회
 * @returns
 */
export const fetchBookable = async (
  wishedAt: string
): Promise<RepairShopThisBookableInfo> => {
  const url = `${URL}/bookable`;
  const response = await httpRequest({
    method: axiosUtils.GET,
    url,
    queryParams: { wishedAt },
  });

  return response?.data.row;
};
